<template>
  <div>
    <v-footer fluid fixed inset app :style="{height: (expand ? '200px' : '53px')}" style="border-top: 1px solid rgba(0,0,0,.12); margin-left: 80px;">
      <v-card flat width="100%" height="100%" style="padding-right: 86px;" :style="{'overflow-y': (value ? 'auto' : 'initial')}">
        <v-data-table
          :headers="headers"
          :items="filtered_processes"
          :hide-headers="!expand"
          :hide-actions="true"
          :disable-initial-sort="true"
          no-data-text=""
          class="process-table">
          <template slot="items" slot-scope="props">
            <ProcessItem v-show="(!expand && props.index == 0) || expand" :type="props.item.type" v-model="props.item"></ProcessItem>
          </template>
        </v-data-table>
        <v-btn v-show="process_list.length > filtered_processes.length" flat small @click="() => { visible_count += 10; }">Show more...</v-btn>
      </v-card>
      <v-spacer></v-spacer>
      <div style="position: absolute; top: 0; right: 84px;">
        <v-btn icon class="mr-0" @click="() => { expand = !expand; }"><v-icon>{{expand ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}</v-icon></v-btn>
      </div>
    </v-footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProcessItem from './processbar/Item'
export default {
  props: ['value'],
  components: {
    ProcessItem
  },
  data: () => ({
    headers: [
      {text: '', value: 'status', sortable: false, width: 20},
      {text: 'Description', value: 'description', sortable: false},
      {text: "Created at", value: "created_at"},
      {text: '', value: 'actions', sortable: false, align: "right"}
    ],
    visible_count: 10
  }),
  computed: {
    expand: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    process_count() {
      return this.process_list.length;
    },
    filtered_processes() {
      var list = _.orderBy(this.process_list, ['created_at'], ['desc']);
      return _.take(list, this.visible_count);
    },
    ...mapGetters({
      process_list: 'processes/list'
    })
  }
}
</script>

<style>
  .process-table .v-table thead tr {
    height: 40px;
  }
</style>
